import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ToolsIcon = function ToolsIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ToolsIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.154 1.487a.725.725 0 0 1 1.025 0l2.808 2.808 2.25-2.25a2.629 2.629 0 0 1 3.718 3.718l-2.25 2.25 2.808 2.808a.725.725 0 0 1 0 1.025l-2.667 2.667a.725.725 0 0 1-1.025 0l-2.808-2.808-2.808 2.808a.73.73 0 0 1-.513.212H2A.725.725 0 0 1 1.275 14v-2.692c0-.193.076-.377.212-.513l2.808-2.808L1.487 5.18a.725.725 0 0 1 0-1.025zm6 6a.7.7 0 0 1 .127-.101l1.04-1.04L9.654 4.68l-1.04 1.04a.7.7 0 0 1-.229.229L5.948 8.385a.7.7 0 0 1-.23.23l-2.993 2.993v1.667h1.667l2.994-2.994a.7.7 0 0 1 .229-.229l2.437-2.437a.7.7 0 0 1 .102-.128m.525 1.551L9.038 10.68l.629.628.487-.487a.725.725 0 0 1 1.025 1.025l-.487.487.641.642 1.642-1.642zM4.667 3.025l2.295 2.296L5.32 6.96l-.628-.628.487-.487A.725.725 0 0 0 4.154 4.82l-.487.487-.642-.641zm7.68 2.296.583-.584a1.179 1.179 0 0 0-1.667-1.667l-.584.584z",
      clipRule: "evenodd"
    })
  }));
};

export { ToolsIcon };
